import { Directive, Output , HostListener, ElementRef, EventEmitter } from '@angular/core';
import { ExpertColorOptions } from './expert-color.component';

@Directive({
  selector: '[colorPlaceholderNullOnClick]'
})

export class ColorPlaceholderNull {
   constructor(private _elementRef : ElementRef , private expertColOptions : ExpertColorOptions) {
    }

    @Output()
    public colorPlaceholderNullOnClick = new EventEmitter();

 /* To capture all clicks on the host element of the document and 
 check if the click is inside or outside of the element*/
    @HostListener('document:click', ['$event','$event.target'])
    public onClick(event: MouseEvent, targetElement:HTMLElement) {
        if(!this._elementRef.nativeElement.contains(targetElement))
        {               
            this.expertColOptions.expertColorOptions="";
        }
    }



}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-color/expert-color-placeholder-null.ts